var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footNote"},[_c('p',[_c('span',[_vm._v(" 公司名称：海南玄鸟信息技术有限公司 ")])]),_vm._v(" "),_c('p',[_c('span',[_vm._v(" 公司地址：海南省澄迈县老城镇高新技术产业示范区海南生态软件园A25幢四层106号")])]),_vm._v(" "),_c('p',[_c('span',[_vm._v(" 联系电话：18779117562")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4afdacba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/blog-foot.vue
// module id = null
// module chunks = 